import React, { FunctionComponent, ReactNode } from 'react';

import { TableHeadingAction, TableHeadingActionType, TableHeadingOptions } from './TableHeading.constants';
import Button, { ButtonSizes } from '../../Button';
import Typography, { TypographyVariants } from '../../Typography';

export type TableHeadingProps = {
  tableId: string;
  compact?: boolean;
  selectedRows?: string[];
  areAllRowsSelected?: boolean;
};

type Props = TableHeadingProps & TableHeadingOptions;

const TableHeading: FunctionComponent<Props> = ({
  tableId,
  compact = false,
  heading,
  actions,
  selectedRows,
  areAllRowsSelected,
}) => {
  const buttonSize = compact ? ButtonSizes.normal : ButtonSizes.big;
  const headingSize = compact ? TypographyVariants.h2 : TypographyVariants.h1;

  const renderActionButton = ({ id, label, type, icon, handleOnClick }: TableHeadingAction): ReactNode => {
    let text = label;
    let onClickHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
      event.preventDefault();
      handleOnClick();
    };

    if (type === TableHeadingActionType.selection) {
      const numberOfSelectedRows = selectedRows?.length || 0;
      if (numberOfSelectedRows === 0) {
        return;
      }

      text = `${label} ${areAllRowsSelected ? 'all' : `(${numberOfSelectedRows} rows)`}`;

      onClickHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();
        handleOnClick(selectedRows, areAllRowsSelected);
      };
    }

    return (
      <Button
        key={id}
        text={text}
        size={buttonSize}
        primary={type === TableHeadingActionType.primary}
        icon={icon}
        onClick={onClickHandler}
      />
    );
  };

  return (
    <div className="mba-heading--wrapper mba-heading--table">
      {heading && (
        <Typography component="p" variant={headingSize} className="mba-heading--title-2">
          {heading}
        </Typography>
      )}
      {actions && (
        <div className="mba-actions">
          {actions.map((action: TableHeadingAction, index: number) =>
            renderActionButton({
              ...action,
              id: `${tableId}-action-${index}`,
            }),
          )}
        </div>
      )}
    </div>
  );
};

export default TableHeading;
